import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-voorheffingen-divBel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-voorheffingen-divBel.component.html',
  styleUrl: './tekst-voorheffingen-divBel.component.scss',
})
export class TekstVoorheffingenDivBelComponent implements OnInit {

@Input() public id!: string;
public ibAangifte = {} as Aangifte;
public focusedElementId: string | null = null;
public year = 2024;
public actualYear: number = new Date().getFullYear();

  constructor(
      public dataService: BokkzIbDataService) {
  }

  ngOnInit(): void {
    this.dataService.incomeTaxEntity.subscribe((value) => {
      if (value.year !== undefined) {
        this.year = value.year;
      }
    })
  }

}
